var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M15.9 5.832l-.95.956.45.452-2.25-.013V0H0v15.838L6.65 18l-.032-2.162h6.532V8.654l2.25-.006-.5.402.95 1.056L18 7.994zm-4.1 1.46H8.05v1.406h3.75v5.833H6.55V2.01l-2-.552h7.25z","stroke-width":".05"}})}
var staticRenderFns = []

export { render, staticRenderFns }